import { render, staticRenderFns } from "./projectMembers.vue?vue&type=template&id=b31079dc&scoped=true&"
import script from "./projectMembers.vue?vue&type=script&lang=js&"
export * from "./projectMembers.vue?vue&type=script&lang=js&"
import style0 from "./projectMembers.vue?vue&type=style&index=0&id=b31079dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31079dc",
  null
  
)

export default component.exports